var map = {
	"./buffle.png": "./src/chinese-astrology-block/images/buffle.png",
	"./cheval.png": "./src/chinese-astrology-block/images/cheval.png",
	"./chevre.png": "./src/chinese-astrology-block/images/chevre.png",
	"./chien.png": "./src/chinese-astrology-block/images/chien.png",
	"./cochon.png": "./src/chinese-astrology-block/images/cochon.png",
	"./coq.png": "./src/chinese-astrology-block/images/coq.png",
	"./dragon.png": "./src/chinese-astrology-block/images/dragon.png",
	"./lapin.png": "./src/chinese-astrology-block/images/lapin.png",
	"./rat.png": "./src/chinese-astrology-block/images/rat.png",
	"./serpent.png": "./src/chinese-astrology-block/images/serpent.png",
	"./singe.png": "./src/chinese-astrology-block/images/singe.png",
	"./tigre.png": "./src/chinese-astrology-block/images/tigre.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/chinese-astrology-block/images sync recursive ^\\.\\/.*\\.png$";